import { Link } from "react-router-dom"
import { ArrowRight } from "lucide-react"
import "./HomePage.css"

function HomePage() {
  return (
    <div className="home-page-wrapper">
      <div className="home-container">
        {/* Hero Section */}
        <section className="hero-section">
          <div className="hero-content">
            <h1 className="hero-title">
              Plataforma de <span className="text-gradient">Certificados Digitales</span>
            </h1>
            <p className="hero-description">
              Tu plataforma centralizada para la gestión y verificación de certificados digitales. Emite, consulta y
              verifica credenciales de manera rápida y confiable con tecnología eficiente.
            </p>
            <div className="hero-actions">
              <Link to="/student/certificates" className="primary-button">
                Mis Certificados
                <ArrowRight className="button-icon" />
              </Link>
              <Link to="/verify/student/certificates" className="secondary-button">
                Verificar Certificado
              </Link>
            </div>
          </div>
          <div className="hero-image-container">
            {/* Imagen principal del certificado */}
            <div className="hero-image">
              <img src="./assets/UH_3D.png" alt="Certificado digital" className="certificate-image" />
              <div className="image-glow"></div>
            </div>

            {/* Segunda imagen - Birrete con rotación suave */}
            <div className="secondary-image-1">
              <img src="/assets/birrete_3D.png" alt="Birrete de graduación" className="badge-image" />
              <div className="badge-glow"></div>
            </div>

            {/* Tercera imagen - UI con pulso y escala */}
            <div className="secondary-image-2">
              <img src="/assets/certificado_3D.png" alt="Interfaz digital" className="diploma-image" />
              <div className="diploma-glow"></div>
            </div>
          </div>
        </section>
      </div>
    </div>
  )
}

export default HomePage
